var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BorderBox',{staticClass:"track-alarm-table"},[_c('MTable',{attrs:{"i18nPath":_vm.i18nPath,"tableData":_vm.alarmList,"tableColumn":_vm.tableColumn,"has-pagination":false,"height":"100%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }